const addressBarChromeMobileVH = {
	el: {
		body: document.body,
		hero: document.querySelector('.js-hero'),
		header: document.querySelector('.header')
	},

	vars: {
		extraLargeAndUp: window.matchMedia('(min-width: 80em)')
	},

	fxDetectHeight() {
		if (!this.el.hero) return

		const heightHeader = this.el.header.offsetHeight,
			heightFinal = window.innerHeight - heightHeader

		this.el.hero.style.height = `${heightFinal}px`

		window.addEventListener('resize', () => {
			// Update window Height size
			const heightFinal = window.innerHeight - heightHeader
			// Update sizes
			this.el.hero.style.height = `${heightFinal}px`
		})
	},

	events() {
		this.vars.extraLargeAndUp.addEventListener('change', () => this.fxDetectHeight())
	},

	init() {
		this.events()
		this.fxDetectHeight()
	}
}

addressBarChromeMobileVH.init()